import { jwtDecode } from 'jwt-decode'

const TOKEN_REFRESH_OFFSET_IN_MS = 18_000

export const getOperatorAccessTokenRefreshInterval = (accessToken: string) => {
  const { exp } = jwtDecode<{
    exp: number
  }>(accessToken)
  const currentTimeInSec = Math.floor(Date.now() / 1000)
  const tokenExpiryTimeInSec = exp

  return (tokenExpiryTimeInSec - currentTimeInSec) * 1000 - TOKEN_REFRESH_OFFSET_IN_MS
}
